"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotoNav = void 0;
var Cookies = require("js-cookie");
var $ = require("jquery");
var PhotoNav = (function () {
    function PhotoNav() {
    }
    PhotoNav.clearRail = function () {
        Cookies.remove("rail");
    };
    PhotoNav.switchToRail = function (type, key) {
        var railName = type + "/" + key;
        Cookies.set("rail", railName, { expires: 7 });
        return railName;
    };
    PhotoNav.switchAndGoNext = function (currentPhoto, type, key) {
        var rail = this.switchToRail(type, key);
        $(window).attr("location", "/Photo/NextPhoto?photo=" + currentPhoto + "&rail=" + rail);
    };
    PhotoNav.switchAndGoPrev = function (currentPhoto, type, key) {
        var rail = this.switchToRail(type, key);
        $(window).attr("location", "/Photo/PreviousPhoto?photo=" + currentPhoto + "&rail=" + rail);
    };
    PhotoNav.resolveNav = function (photoId) {
        var currentRailJoined = Cookies.get("rail");
        var railParts = [];
        if (currentRailJoined) {
            railParts = currentRailJoined.split("/");
        }
        var currentRail;
        if (railParts.length != 2) {
            currentRail = undefined;
        }
        else {
            currentRail = railParts[0].toLowerCase();
        }
        this.manageRandomRail(currentRail, photoId);
        if (!currentRail) {
            currentRail = "random";
        }
        this.prefetchNavLinks(photoId);
        if (currentRail == "random") {
            $("#nextDropRandom").addClass("active");
            $("#nextDropTag").addClass("disabled");
        }
        if (currentRail == "tag") {
            $("#nextDropTag").addClass("active");
        }
        if (currentRail == "batch") {
            $("#nextDropBatch").addClass("active");
            $("#nextDropTag").addClass("disabled");
        }
    };
    PhotoNav.prefetchNavLinks = function (photoId) {
        $.get("/photo/getnav?photo=" + photoId, function (data, status) {
            if (status == "success") {
                $("#nextLink").attr("href", data.next);
                $("#previousLink").attr("href", data.prev);
            }
        });
    };
    PhotoNav.manageRandomRail = function (rail, photoId) {
        var randomCookieName = "randomrailphoto";
        if (rail == "random") {
            Cookies.set(randomCookieName, photoId);
        }
        else {
            var randomPhotoRail = Cookies.get(randomCookieName);
            if (randomPhotoRail) {
                $("#nextDropRandom").attr("href", "/Photo/NextPhoto?photo=" + randomPhotoRail + "&rail=random/r1");
            }
        }
    };
    return PhotoNav;
}());
exports.PhotoNav = PhotoNav;

//# sourceMappingURL=PhotoNav.js.map
